<template>
  <div>
    <div v-if="!valid" class="pb-2 text-error">The following percentages should total 100%</div>
    <slot></slot>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    fields: { type: Array, required: true },
    groupId: { type: String, default: null },
    model: { type: Object, required: true }
  },
  data() {
    return {
      currentTotal: 0
    }
  },
  computed: {
    total() {
      const keys = _.map(this.fields, field => field.model)
      const values = _.map(
        _.pickBy(this.model, (value, key) => keys.indexOf(key) !== -1),
        value => parseInt(value, 10)
      )

      return _.reduce(values, (sum, n) => sum + n)
    },
    valid() {
      return this.total === 100
    }
  },
  watch: {
    model: {
      handler: function() {
        const vm = this
        if (this.currentTotal !== this.total) {
          this.currentTotal = this.total
          if (this.groupId) {
            this.$emit('change', { model: this.groupId, valid: vm.valid })
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.currentTotal = this.total
    if (this.groupId) {
      this.$emit('change', { model: this.groupId, valid: this.valid })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-error {
  color: var(--v-error-base);
}
</style>
